export const pageSettings = `pageSettings {
  settings {
    colorScheme
  }
}`;

export const pageFields = `pageComponents {
    fields {
      ... on PageComponentsFieldsBrandHeroLayout {
        fieldGroupName
        brandHero {
          heroSlides {
            heroSlide {
              title
              details {
                copy
                headline
                cta {
                  url
                  title
                  target
                }
              }
              mobileHeroImage {
                node {
                  altText
                  mediaItemUrl
                  mediaDetails {
                    height
                    width
                  }
                }
              }
              heroImage {
                node {
                  altText
                  mediaItemUrl
                  mediaDetails {
                    height
                    width
                  }
                }
              }
            }
          }
        }
      }
      ... on PageComponentsFieldsHomeHeroLayout {
        fieldGroupName
        homeHero {
          copy
          headline
          subheadline
          background {
            node {
              mediaItemUrl
              mediaDetails {
                height
                width
              }
              altText
            }
          }
          cta {
            url
            title
          }
          image {
            node {
              mediaItemUrl
              mediaDetails {
                width
                height
              }
              altText
            }
          }
        }
      }
      ... on PageComponentsFieldsStatsLayout {
        fieldGroupName
        stats {
          copy
          secondaryCopy
          headline
          cards {
            card {
              copy
              title
            }
          }
          cta {
            url
            title
          }
        }
      }
      ... on PageComponentsFieldsBenefitsLayout {
        fieldGroupName
        benefits {
          copy
          headline
          list {
            benefit {
              copy
              title
              cta {
                url
                title
              }
              image {
                node {
                  mediaItemUrl
                  mediaDetails {
                    height
                    width
                  }
                }
              }
            }
          }
          cta {
            url
            title
          }
        }
      }
      ... on PageComponentsFieldsVideoBannerLayout {
        fieldGroupName
        videoBanner {
          headline
          copy
          youtubeLink
          embeddedVideoLink
          video {
            node {
              mediaItemUrl
              mimeType
              mediaDetails {
                height
                width
              }
            }
          }
        }
      }
      ... on PageComponentsFieldsSuccessLayout {
        fieldGroupName
        success {
          headline
          copy
          cta {
            url
            title
          }
          cards {
            card {
              percent
              eyebrow
              copy
            }
          }
        }
      }
      ... on PageComponentsFieldsCalloutBannerLayout {
        fieldGroupName
        calloutBanner {
          headline
          copy
          includeServicesForm
          patternSelect
          cta {
            url
            title
            target
          }
        }
      }
      ... on PageComponentsFieldsContentHeroLayout {
        fieldGroupName
        contentHero {
          eyebrow
          copy
          showNewsletter
          headline
          patternSelect
          cta {
            title
            url
          }
          image {
            node {
              mediaItemUrl
              mediaDetails {
                height
                width
              }
              altText
            }
          }
        }
      }

    ... on PageComponentsFieldsLpHeroLayout {
          fieldGroupName
          lpHero {
            copy
            eyebrow
            headline
            patternSelect
            showNewsletter
            image {
              node {
                mediaItemUrl
                mediaDetails {
                  width
                  height
                }
              }
            }
          }
        }

      ... on PageComponentsFieldsTestimonialsLayout {
        fieldGroupName
        testimonials { 
          patternSelect
          testimonials {
            testimonial {
              title
              name
              copy
              image {
                node {
                  altText
                  mediaItemUrl
                  mediaDetails {
                    height
                    width
                  }
                }
              }
            }
          }
        }
      }
      ... on PageComponentsFieldsFeatureHighlightLayout {
        fieldGroupName
        featureHighlight {
          copy
          contentOnRight
          headline
          image {
            node {
              altText
              mediaItemUrl
              mediaDetails {
                width
                height
              }
            }
          }
          cta {
            url
            title
          }
        }
      }
      ... on PageComponentsFieldsCapabilitiesLayout {
        fieldGroupName
        capabilities {
          headline
          copy
          cards {
            title
            cta {
              url
              title
              target
            }
            cardcopy
            image {
              node {
                mediaItemUrl
                mediaDetails {
                  width
                  height
                }
                altText
              }
            }
          }
        }
      }
      ... on PageComponentsFieldsContentBlockLayout {
        fieldGroupName
        contentBlock {
          imageOnRight
          headline
          image {
            node {
              altText
              mediaItemUrl
              mediaDetails {
                height
                width
              }
            }
          }
          contentItems {
            title
            copy
            cta {
              url
              title
              target
            }
          }
        }
      }
      ... on PageComponentsFieldsLeadershipLayout {
        fieldGroupName
        leadership {
          leaders {
            leader {
              edges {
                node {
                  ... on Leader {
                    id
                    leadershipfields {
                      description
                      email
                      name
                      title
                      linkedin
                      image {
                        node {
                          altText
                          mediaItemUrl
                          mediaDetails {
                            width
                            height
                          }
                        }
                      }
              
                    }
                  }
                }
              }
            }
          }
        }
      }
      ... on PageComponentsFieldsProductCapabilitiesLayout {
        fieldGroupName
        productCapabilities {
          headline
          copy
          productCategories {
            productCategoryTitle
            cards {
              title
              cardcopy
              cta {
                url
                title
                target
              }
              image {
                node {
                  altText
                  mediaItemUrl
                  mediaDetails {
                    width
                    height
                  }
                }
              }
            }
          }
        }
      }
      ... on PageComponentsFieldsLatestNewsLayout {
        fieldGroupName
        latestNews {
          title
          showLatest
          newsItems {
            newsItem {
              edges {
                node {
                  uri
                  blogMetaFields {
                    author
                    title
                    publishDate
                    summary
                    thumbnailImage {
                      node {
                        mediaItemUrl
                        altText
                        mediaDetails {
                          width
                          height
                        }
                      }
                    }
                    tags {
                      edges {
                        node {
                          ... on Tag {
                            id
                            name
                          }
                        }
                      }
                    }
                    heroImage {
                      node {
                        altText
                        mediaItemUrl
                        mediaDetails {
                          width
                          height
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      ... on PageComponentsFieldsOpeningsLayout {
        fieldGroupName
        openings {
          headline
        }
      }
      ... on PageComponentsFieldsBrandBannerLayout {
        fieldGroupName
        brandBanner {
          title
          cta {
            title
            url
          }
          brands {
            logo {
              node {
                mediaItemUrl
                mediaDetails {
                  width
                  height
                }
                altText
              }
            }
          }
        }
      }
      ... on PageComponentsFieldsSolutionsLayout {
        fieldGroupName
        solutions {
          copy
          headline
          solutionItems {
            copy
            title
            headline
            image {
              node {
                altText
                mediaItemUrl
                mediaDetails {
                  width
                  height
                }
              }
            }
            cta {
              url
              title
              target
            }
          }
        }
      }
      ... on PageComponentsFieldsContactFormLayout {
        fieldGroupName
        contactForm {
          headline
        }
      }
      ... on PageComponentsFieldsLocationsLayout {
        fieldGroupName
        locations {
          headline
          locationCards {
            locationCard {
              title
              address {
                city
                country
                countryShort
                state
                streetAddress
                streetName
                streetNumber
                postCode
                placeId
              }
              mapLink {
                url
                title
                target
              }
            }
          }
        }
      }
      ... on PageComponentsFieldsBlogCalloutLayout {
        fieldGroupName
        blogCallout {
          fieldGroupName
        }
      }
      ... on PageComponentsFieldsTextContentLayout {
        fieldGroupName
        textContent
      }
      ... on PageComponentsFieldsHubspotFormLayout {
        fieldGroupName
        hubspotForm {
          formId
          portalId
        }
      }
      ... on PageComponentsFieldsContactCardsLayout {
        fieldGroupName
        contactCards {
          cards {
            title
            link {
              url
              title
              target
            }
            image {
              node {
                altText
                mediaItemUrl
                mediaDetails {
                  width
                  height
                }
              }
            }
          }
        }
      }
      ... on PageComponentsFieldsTextHeroLayout {
        fieldGroupName
        textHero {
          title
        }
      }
	  ... on PageComponentsFieldsTeamMemberTilesLayout {
			teamMemberTiles {
                headline
                teamMembers {
                  fieldGroupName
                  name
                  title
                  headshot {
                    node {
                      altText
                      mediaItemUrl
					  mediaDetails {
							width
							height
						}
                    }
                  }
                }
              }
		}

    }
  }`;
  export const seoSchemaQuery = `
  seo {
    schema {
      raw
    }
  }
  `;
export const seoQuery = `seo {
  breadcrumbs {
    text
    url
  }
  canonical
  cornerstone
  focuskw
  fullHead
  metaDesc
  metaKeywords
  metaRobotsNofollow
  metaRobotsNoindex
  opengraphAuthor
  opengraphDescription
  opengraphImage {
    sourceUrl
  }
  opengraphModifiedTime
  opengraphPublishedTime
  opengraphPublisher
  opengraphSiteName
  opengraphTitle
  opengraphType
  opengraphUrl
  schema {
    articleType
    pageType
    raw
  }
  title
  twitterDescription
  twitterImage {
    sourceUrl
  }
  twitterTitle
}`;
export const generateRoutesFields = `pages(last: 100) {
    nodes {
      slug
      parentId
      children {
        nodes {
          slug
        }
      }
    }
}`;

export const blogFields = `blogComponents {
  components {
    ... on BlogComponentsComponentsBiographyCalloutLayout {
      fieldGroupName
      biographyCallout {
        title
        name
        link {
          url
          title
          target
        }
        copy
        image {
          node {
            altText
            mediaItemUrl
            mediaDetails {
              width
              height
            }
          }
        }
      }
    }
    ... on BlogComponentsComponentsBarGraphsLayout {
      fieldGroupName
      barGraphs {
        graphs {
          title
          percentFull
          label
          color
        }
      }
    }
    ... on BlogComponentsComponentsCircleGraphsLayout {
      fieldGroupName
      circleGraphs {
        graphs {
          title
          percentFull
          label
          color
        }
      }
    }
    ... on BlogComponentsComponentsTwoColumnChartLayout {
      fieldGroupName
      twoColumnChart {
        sections {
          leftColumnCopy
          leftColumnLabel
          rightColumnCopy
          rightColumnLabel
          sectionLabel
        }
      }
    }
    ... on BlogComponentsComponentsThreeColumnChartLayout {
      fieldGroupName
      threeColumnChart {
        fieldGroupName
        rightColumnLabel
        middleColumnLabel
        leftColumnLabel
        sections {
          sectionLabel
          rightColumnValue
          middleColumnValue
          leftColumnValue
        }
      }
    }
    ... on BlogComponentsComponentsLeadMagnetLayout {
      fieldGroupName
      leadMagnet {
        copy
        headline
        bulletList {
          bulletPoint
        }
        secondaryCta {
          url
          title
          target
        }
        primaryCta {
          url
          title
          target
        }
        image {
          node {
            altText
            mediaItemUrl
            mediaDetails {
              width
              height
            }
          }
        }
      }
    }
    ... on BlogComponentsComponentsParagraphAndImageLayout {
      fieldGroupName
      paragraphandimage {
        copy
        imageOnRight
        imageCaption
        image {
          node {
            altText
            mediaItemUrl
            mediaDetails {
              file
              width
              height
            }
          }
        }
      }
    }
    ... on BlogComponentsComponentsImageContentLayout {
      fieldGroupName
      imageContent {
        caption
        image {
          node {
            altText
            mediaItemUrl
            mediaDetails {
              width
              file
              height
            }
          }
        }
      }
    }
    ... on BlogComponentsComponentsBlogStatsLayout {
      fieldGroupName
      blogStats {
        cards {
          statcard {
            headline
            copy
          }
        }
      }
    }
    ... on BlogComponentsComponentsTranscriptLayout {
      fieldGroupName
      transcript {
        headline
        textContent
      }
    }
    ... on BlogComponentsComponentsLatestNewsLayout {
      fieldGroupName
      latestNews {
        title
        showLatest
        newsItems {
          newsItem {
            edges {
              node {
                uri
                blogMetaFields {
                  hideSidebar
                  author
                  title
                  publishDate
                  summary
                  thumbnailImage {
                    node {
                      mediaItemUrl
                      altText
                      mediaDetails {
                        width
                        height
                      }
                    }
                  }
                  tags {
                    edges {
                      node {
                        ... on Tag {
                          id
                          name
                        }
                      }
                    }
                  }
                  heroImage {
                    node {
                      altText
                      mediaItemUrl
                      mediaDetails {
                        width
                        height
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    ... on BlogComponentsComponentsBlogCalloutLayout {
      fieldGroupName
      blogCallout {
        fieldGroupName
      }
    }
    ... on BlogComponentsComponentsTestimonialsLayout {
      fieldGroupName
      testimonials {
        testimonials {
          testimonial {
            title
            name
            copy
            image {
              node {
                altText
                mediaItemUrl
                mediaDetails {
                  height
                  width
                }
              }
            }
          }
        }
      }
    }
    ... on BlogComponentsComponentsVideoBannerLayout {
      fieldGroupName
      videoBanner {
        headline
        copy
        youtubeLink
        embeddedVideoLink
        video {
          node {
            mediaItemUrl
            mimeType
            mediaDetails {
              height
              width
            }
          }
        }
      }
    }
    ... on BlogComponentsComponentsTextContentLayout {
      fieldGroupName
      textContent
    }
    ... on BlogComponentsComponentsBlogHeadlineLayout {
      fieldGroupName
      blogHeadline {
        headline
        textAlign
        fontStyle
      }
    }
    ... on BlogComponentsComponentsBlogSubheadlineLayout {
      fieldGroupName
      blogSubheadline {
        subheadline
        textAlign
        fontStyle
      }
    }
	  ... on BlogComponentsComponentsTeamMemberTilesLayout {
              fieldGroupName
              teamMemberTiles {
                headline
                teamMembers {
                  fieldGroupName
                  name
                  title
                  headshot {
                    node {
                      altText
                      mediaItemUrl
					  mediaDetails {
							width
							height
						}
                    }
                  }
                }
              }
            } 
  }
}`;
export const blogContentFields = `
  blogContent {
    blogSections {
      blogSection {
        sectionTitle
        sectionContent {
          ... on BlogContentBlogSectionsBlogSectionSectionContentTestimonialLayout {
            fieldGroupName
          }
          ... on BlogContentBlogSectionsBlogSectionSectionContentBlogStatsLayout {
            fieldGroupName
          }
          ... on BlogContentBlogSectionsBlogSectionSectionContentTextContentLayout {
            fieldGroupName
          }
          ... on BlogContentBlogSectionsBlogSectionSectionContentVideoBannerLayout {
            fieldGroupName
          }
          ... on BlogContentBlogSectionsBlogSectionSectionContentSubheadlineLayout {
            fieldGroupName
            subheadline
          }
        }
      }
    }
  }
`;

export const blogMeta = `blogMetaFields {
  title
  hideSidebar
  publishDate
  summary
  author
  metaFull
  thumbnailImage {
    node {
      mediaItemUrl
      altText
      mediaDetails {
        width
        height
      }
    }
  }
  tags {
    edges {
      node {
        ... on Tag {
          id
          name
        }
      }
    }
  }
  heroImage {
    node {
      altText
      mediaItemUrl
      mediaDetails {
        width
        height
      }
    }
  }
  blogPromo {
    promoCopy
    promoImage {
      node {
        altText
        mediaItemUrl
        mediaDetails {
          width
          height
        }
      }
    }
    promoCta {
      url
      title
      target
    }
  }
}`

export const leadershipQuery = `query LeaderQuery {
  leaders(last: 100) {
    nodes {
      leadershipfields {
        description
        email
        name
        title
        linkedin
        image {
          node {
            altText
            mediaItemUrl
            mediaDetails {
              width
              height
            }
          }
        }

      }
    }
  }
}`;


export const siteSearchQuery = `query SearchContent($search: String!, $first: Int!, $after: String){
  contentNodes(where: {status: PUBLISH, search: $search, contentTypes: [PAGE, POST, NEWS, INSIGHTS, SUCCESS_STORIES, WEBINAR, PODCAST]}, first: $first, after: $after) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
        uri
        blogMetaFields {
          author
          title
          summary
          heroImage {
            node {
              altText
              mediaItemUrl
              mediaDetails {
                width
                height
              }
            }
          }
        }
        ... on Page {
          id
          title
          content
        }
      }
    }
  }
}`
export const latestNewsQuery =`query LatestNews {
  contentNodes(
    where: { contentTypes: [NEWS], status: PUBLISH, orderby: { field: DATE, order: DESC } }
    first: 3
  ) {
    edges {
      node {
        id
        uri
        blogMetaFields {
          author
          title
          publishDate
          thumbnailImage {
            node {
              altText
              mediaItemUrl
              mediaDetails {
                width
                height
              }
            }
          }
          heroImage {
            node {
              altText
              mediaItemUrl
              mediaDetails {
                width
                height
              }
            }
          }
        }
      }
    }
  }
}`;

export const createBlogSearchQuery = (contentTypes) => {
  const defaultContentTypes = ["NEWS", "SUCCESS_STORIES", "INSIGHTS", "WEBINAR", "PODCASTS"];
  const contentTypesString = contentTypes.length > 0 ? contentTypes.join(", ") : defaultContentTypes.join(", ");
  const query = (searchProvided) => `
    query SearchBlogs( ${searchProvided ? '$search: String,' : ''}$first: Int!, $after: String, $before: String) {
      contentNodes(
        where: {
          status: PUBLISH,
          ${searchProvided ? 'search: $search,' : ''}
          contentTypes: [${contentTypesString}]
        }, 
        first: $first, 
        after: $after, 
        before: $before
      ) {
        pageInfo {
          hasPreviousPage
          hasNextPage
          startCursor
          endCursor
        }
        edges {
          cursor
          node {
            id
            uri
            blogMetaFields {
              author
              title
              publishDate
              thumbnailImage {
                node {
                  altText
                  mediaItemUrl
                  mediaDetails {
                    width
                    height
                  }
                }
              }
              heroImage {
                node {
                  altText
                  mediaItemUrl
                  mediaDetails {
                    width
                    height
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  return query;
};

export const createInitialBlogQuery = (contentTypes) => {
  const defaultContentTypes = ["NEWS", "SUCCESS_STORIES", "INSIGHTS", "WEBINAR", "PODCASTS"];
  const contentTypesString = contentTypes.length > 0 ? contentTypes.join(", ") : defaultContentTypes.join(", ");
  const query = `
    query InitialBlogs {
      contentNodes(where: {status: PUBLISH, contentTypes: [${contentTypesString}]}, first: 9) {
        pageInfo {
          hasPreviousPage
          hasNextPage
          startCursor
          endCursor
        }
        edges {
          cursor
          node {
            id
            uri
            blogMetaFields {
              author
              title
              publishDate
              thumbnailImage {
                node {
                  altText
                  mediaItemUrl
                  mediaDetails {
                    width
                    height
                  }
                }
              }
              heroImage {
                node {
                  altText
                  mediaItemUrl
                  mediaDetails {
                    width
                    height
                  }
                }
              }
            }
          }
        }
      }
    }
  `;
  return query;
}
export const demoPageFields = `demoPageFields {
  content
  testimonialBlock {
    title
    name
    copy
    image {
      node {
        altText
        mediaItemUrl
        mediaDetails {
          height
          width
        }
      }
    }
  }
  formFields {
    portalId
    formId
  }
}`;

export const loginPageFields = `loginPageFields {
  loginLinks {
    headline
    loginLink {
      url
      title
      target
    }
  }
  banner {
    title
    copy
    image {
      node {
        altText
        mediaItemUrl
        mediaDetails {
          width
          height
        }
      }
    }
  }
}`;

export const termsPageFields = `termsPageFields {
  termsLinkList {
  termsLinkGroup {
    title
    linkList {
      dateText
      link {
        title
        url
        target
      }
    }
  }
  }
}`
export const footerQuery = `query FooterQuery {
  siteSettings {
    siteSettingsFields {
      footerSocial {
        socialLink
      }
      address
      financeStatement
      copyright
      footerLogo {
        node {
          altText
          mediaItemUrl
          mediaDetails {
            height
            width
          }
        }
      }
    }
  }
}`;



export const getAllBlogs = `
query GetAllBlogsByType(
  $afterNews: String
  $afterSuccess: String
  $afterInsights: String
  $afterWebinars: String
  $afterPodcasts: String
) {
  news(first: 100, where: { status: PUBLISH }, after: $afterNews) {
    pageInfo { endCursor hasNextPage }
    edges {
      cursor
      node {
        __typename
        id
        uri
        blogMetaFields {
          author
          title
          publishDate
          thumbnailImage {
            node {
              altText
              mediaItemUrl
              mediaDetails { width height }
            }
          }
          heroImage {
            node {
              altText
              mediaItemUrl
              mediaDetails { width height }
            }
          }
        }
      }
    }
  }
  projectThrives(first: 100, where: { status: PUBLISH }, after: $afterSuccess) {
    pageInfo { endCursor hasNextPage }
    edges {
      cursor
      node {
        __typename
        id
        uri
        blogMetaFields {
          author
          title
          publishDate
          thumbnailImage {
            node {
              altText
              mediaItemUrl
              mediaDetails { width height }
            }
          }
          heroImage {
            node {
              altText
              mediaItemUrl
              mediaDetails { width height }
            }
          }
        }
      }
    }
  }
  successStories(first: 100, where: { status: PUBLISH }, after: $afterSuccess) {
    pageInfo { endCursor hasNextPage }
    edges {
      cursor
      node {
        __typename
        id
        uri
        blogMetaFields {
          author
          title
          publishDate
          thumbnailImage {
            node {
              altText
              mediaItemUrl
              mediaDetails { width height }
            }
          }
          heroImage {
            node {
              altText
              mediaItemUrl
              mediaDetails { width height }
            }
          }
        }
      }
    }
  }

  insights(first: 100, where: { status: PUBLISH }, after: $afterInsights) {
    pageInfo { endCursor hasNextPage }
    edges {
      cursor
      node {
        __typename
        id
        uri
        blogMetaFields {
          author
          title
          publishDate
          thumbnailImage {
            node {
              altText
              mediaItemUrl
              mediaDetails { width height }
            }
          }
          heroImage {
            node {
              altText
              mediaItemUrl
              mediaDetails { width height }
            }
          }
        }
      }
    }
  }
  webinars(first: 100, where: { status: PUBLISH }, after: $afterWebinars) {
    pageInfo { endCursor hasNextPage }
    edges {
      cursor
      node {
        __typename
        id
        uri
        blogMetaFields {
          author
          title
          publishDate
          thumbnailImage {
            node {
              altText
              mediaItemUrl
              mediaDetails { width height }
            }
          }
          heroImage {
            node {
              altText
              mediaItemUrl
              mediaDetails { width height }
            }
          }
        }
      }
    }
  }
  podcasts(first: 100, where: { status: PUBLISH }, after: $afterPodcasts) {
    pageInfo { endCursor hasNextPage }
    edges {
      cursor
      node {
        __typename
        id
        uri
        blogMetaFields {
          author
          title
          publishDate
          thumbnailImage {
            node {
              altText
              mediaItemUrl
              mediaDetails { width height }
            }
          }
          heroImage {
            node {
              altText
              mediaItemUrl
              mediaDetails { width height }
            }
          }
        }
      }
    }
  }
}
`;
